import React from 'react';
import { Container, Row } from 'react-bootstrap';
import { RadioGroup } from '../Radio';
import SelectableCard from '../SelectableCard';
import ExpandableContentPlanSelection from './ExpandableContentPlanSelection';

const planNames = ['You', 'You & Spouse', 'You & Children', 'You & Family'];

const planPrices = [
  'Consumer Choice HDHP',
  '$80.08',
  '$96.86',
  '$119.43',
  '$171.84',
];

export const planData = {
  planNames,
  planPrices,
};

const ExpandableContentPlanSelectionDemo = () => {
  const [value, setValue] = React.useState<string | number>('test-2');

  const handleChange = (e: string | number) => {
    setValue(e);
  };

  return (
    <Container>
      <Container className="mt-10">
        <h4>Selectable Card - with optional expand</h4>
        <RadioGroup name={'test1'} value={value} onChange={handleChange}>
          <Row>
            <SelectableCard
              title="Consumer Choice HDHP"
              subtitle1="Imputed Income for tax purposes $2,250"
              subtitle2="Sign up for Health Savings Account and receive $1,000!"
              prePaydPeriod={177.24}
              prePaydPeriodSubtitle="3 persons, per-pay-period"
              radioButtonValue="1"
              selected={value === '1'}
            >
              <ExpandableContentPlanSelection
                plansData={planData}
                selectedPlanIndex={0}
              />
            </SelectableCard>
          </Row>
        </RadioGroup>
      </Container>
    </Container>
  );
};

export default ExpandableContentPlanSelectionDemo;
